import { HugeiconsIcon } from '@hugeicons/react';
import { Add01Icon, AppleIcon, ArrowDown01Icon, ArrowRight01Icon, BatteryFullIcon, BedIcon, Briefcase01Icon, Calendar03Icon, Call02Icon, Cancel01Icon, CancelCircleIcon, ChartUpIcon, CheckmarkBadge01Icon, CheckmarkCircle02Icon, ClipboardIcon, ComputerIcon, CreditCardIcon, CursorMagicSelection01Icon, Delete02Icon, DocumentValidationIcon, Door01Icon, DropletIcon, Edit02Icon, FastWindIcon, FavouriteIcon, Fire02Icon, FireExtinguisherIcon, Flag01Icon, FullScreenIcon, GarageIcon, GasPipeIcon, GasStoveIcon, GridIcon, Home01Icon, HomeWifiIcon, House01Icon, InfinityCircleIcon, InternetIcon, Layers01Icon, Layers02Icon, Link01Icon, ListViewIcon, Loading03Icon, Location01Icon, Mail01Icon, Menu01Icon, MinusSignIcon, Money01Icon, MoneyNotFound01Icon, MortarboardIcon, Notification03Icon, PackageIcon, PlayStoreIcon, PlugSocketIcon, PulseIcon, Route01Icon, SatelliteIcon, Search01Icon, SentIcon, Settings02Icon, Shield01Icon, SinkIcon, SmartPhone01Icon, SnowIcon, Sofa01Icon, SparklesIcon, SquareLock01Icon, StarIcon, TemperatureIcon, Tick02Icon, Toilet01Icon, UserGroupIcon, UserIcon, UserIdVerificationIcon, UserMultipleIcon, VolumeHighIcon, WashingtonMonumentIcon, WaterPumpIcon, Wifi01Icon, WifiConnected01Icon } from '@hugeicons/core-free-icons';

/*
 * Icon
 *
 * Every icon on the marketing surface, drawn as inline SVG by Hugeicons.
 *
 * This replaced an icon font. A font renders nothing at all when a name is
 * wrong, which is a silent failure, and it depends on a stylesheet and a
 * webfont arriving before anything is legible. These are components: a bad
 * name is a build error, the stroke inherits the colour you pass it, and there
 * is no flash of missing glyphs.
 *
 * Components ask for icons by SEMANTIC name, 'check', 'water-heater', not by
 * the vendor's name. The map below is the single place the vendor is named, so
 * swapping icon sets again means editing one file rather than forty. Data files
 * (Catalog, NetworkCoverage, ProductSpecs) carry these semantic strings too,
 * which is why they must stay stable.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ICONS = {
  'activity': PulseIcon,
  'apple': AppleIcon,
  'arrow-repeat': Loading03Icon,
  'arrow-right': ArrowRight01Icon,
  'arrows-fullscreen': FullScreenIcon,
  'asterisk': StarIcon,
  'badge-wc-fill': Toilet01Icon,
  'basket2': WashingtonMonumentIcon,
  'battery-full': BatteryFullIcon,
  'bell-fill': Notification03Icon,
  'box-seam': PackageIcon,
  'briefcase-fill': Briefcase01Icon,
  'broadcast': SatelliteIcon,
  'broadcast-pin': WifiConnected01Icon,
  'building': GarageIcon,
  'calendar-event': Calendar03Icon,
  'card-text': DocumentValidationIcon,
  'cash-coin': MoneyNotFound01Icon,
  'cash-stack': Money01Icon,
  'check-circle-fill': CheckmarkCircle02Icon,
  'check-lg': Tick02Icon,
  'chevron-down': ArrowDown01Icon,
  'clipboard-check': ClipboardIcon,
  'cloud-haze2-fill': GasPipeIcon,
  'cpu-fill': ComputerIcon,
  'credit-card': CreditCardIcon,
  'credit-card-2-front': CreditCardIcon,
  'cursor-fill': CursorMagicSelection01Icon,
  'dash-lg': MinusSignIcon,
  'door-closed-fill': Door01Icon,
  'droplet': DropletIcon,
  'droplet-fill': DropletIcon,
  'egg-fried': GasStoveIcon,
  'envelope-fill': Mail01Icon,
  'ethernet': InternetIcon,
  'fire': Fire02Icon,
  'flag-fill': Flag01Icon,
  'geo-alt-fill': Location01Icon,
  'google-play': PlayStoreIcon,
  'graph-up-arrow': ChartUpIcon,
  'grid-fill': GridIcon,
  'heart-fill': FavouriteIcon,
  'house-door-fill': Home01Icon,
  'house-exclamation-fill': House01Icon,
  'house-heart-fill': HomeWifiIcon,
  'infinity': InfinityCircleIcon,
  'layers-fill': Layers01Icon,
  'link-45deg': Link01Icon,
  'list': Menu01Icon,
  'list-nested': ListViewIcon,
  'lock-fill': SquareLock01Icon,
  'moisture': SinkIcon,
  'moon-stars-fill': BedIcon,
  'mortarboard-fill': MortarboardIcon,
  'patch-check-fill': CheckmarkBadge01Icon,
  'pencil-square': Edit02Icon,
  'people': UserMultipleIcon,
  'people-fill': UserGroupIcon,
  'person-badge': UserIdVerificationIcon,
  'person-fill': UserIcon,
  'phone-fill': SmartPhone01Icon,
  'plug-fill': PlugSocketIcon,
  'plus-lg': Add01Icon,
  'search': Search01Icon,
  'send-fill': SentIcon,
  'shield-check': Shield01Icon,
  'signpost-split-fill': Route01Icon,
  'slash-circle': CancelCircleIcon,
  'sliders': Settings02Icon,
  'snow2': SnowIcon,
  'stack': Layers02Icon,
  'star-fill': StarIcon,
  'stars': SparklesIcon,
  'telephone-fill': Call02Icon,
  'thermometer-high': TemperatureIcon,
  'thermometer-snow': FireExtinguisherIcon,
  'trash': Delete02Icon,
  'tv-fill': Sofa01Icon,
  'volume-up-fill': VolumeHighIcon,
  'water': WaterPumpIcon,
  'wifi': Wifi01Icon,
  'wind': FastWindIcon,
  'x-lg': Cancel01Icon
};
const Icon = ({
  className,
  color,
  name,
  size = 16,
  strokeWidth = 1.8,
  style
}) => {
  let icon = ICONS[name];
  if (!icon) {
    // Loud in development, invisible in production, a missing icon should
    // never be the reason a page fails to render.
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Icon: no icon named "${name}"`);
    }
    return null;
  }
  return /*#__PURE__*/_jsx(HugeiconsIcon, {
    className: className,
    color: color || 'currentColor',
    icon: icon,
    size: size,
    strokeWidth: strokeWidth,
    style: {
      flexShrink: 0,
      ...style
    }
  });
};
export default Icon;